export default __webpack_public_path__ + "static/media/cal_bg11.acfd210e.jpg";